
import { useEffect, useState } from 'react';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleJoinGroup = () => {
    const formElement = document.getElementById('networking-form-section');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="min-h-screen bg-black text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-4 sm:top-20 sm:left-20 w-16 h-16 sm:w-32 sm:h-32 border border-yellow-400 rounded-full"></div>
        <div className="absolute bottom-20 right-4 sm:bottom-40 sm:right-20 w-12 h-12 sm:w-24 sm:h-24 border border-yellow-400 rounded-full"></div>
        <div className="absolute top-1/2 left-1/4 w-8 h-8 sm:w-16 sm:h-16 border border-yellow-400 rounded-full"></div>
      </div>

      {/* Logo */}
      <div className="absolute top-4 left-4 sm:top-8 sm:left-8 z-20">
        <img 
          src="/Logo Cashflow LOGO NUEVO Ago 2025.svg"
          alt="Cashflow VIP"
          className="h-24 sm:h-36 w-auto"
        />
      </div>

      <div className="container mx-auto px-4 sm:px-6 py-12 sm:py-20 relative z-10">
        <div className="flex flex-col lg:grid lg:grid-cols-2 gap-8 lg:gap-12 items-center min-h-screen pt-16 sm:pt-20">
          {/* Content */}
          <div className={`space-y-6 sm:space-y-8 text-center lg:text-left transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="space-y-4 sm:space-y-6">
              <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold leading-tight">
                <span className="text-yellow-400">Conecta.</span>{' '}
                <span className="text-yellow-400">Colabora.</span>{' '}
                <span className="text-white">Crece con</span>{' '}
                <span className="text-yellow-400">Cashflow VIP.</span>
              </h1>
              
              <p className="text-lg sm:text-xl lg:text-2xl text-gray-300 leading-relaxed">
                Únete al grupo exclusivo de WhatsApp donde emprendedores, inversionistas y dueños de negocio expanden su red y descubren nuevas oportunidades financieras.
              </p>
            </div>

            <div className="pt-4 sm:pt-6">
              <Button 
                size="lg" 
                onClick={handleJoinGroup}
                className="text-lg sm:text-xl px-8 sm:px-12 py-4 sm:py-6 shadow-2xl w-full sm:w-auto whitespace-nowrap"
              >
                <i className="ri-whatsapp-fill mr-2 sm:mr-3 text-xl sm:text-2xl"></i>
                Únete al grupo de Networking VIP
              </Button>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start space-y-4 sm:space-y-0 sm:space-x-6 pt-4">
              <div className="flex items-center space-x-2">
                <i className="ri-vip-crown-fill text-yellow-400 text-lg sm:text-xl"></i>
                <span className="text-gray-300 text-sm sm:text-base">Comunidad Premium</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-star-fill text-yellow-400 text-lg sm:text-xl"></i>
                <span className="text-gray-300 text-sm sm:text-base">Networking Exclusivo</span>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className={`order-first lg:order-last transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
            <div className="relative max-w-xs sm:max-w-md mx-auto lg:max-w-none px-4 sm:px-0">
              <div className="absolute inset-0 bg-gradient-to-r from-yellow-400/20 to-transparent rounded-2xl"></div>
              <img 
                src="/IMG_94370880.webp"
                alt="Fundadores de Cashflow VIP"
                className="w-full h-auto rounded-2xl shadow-2xl object-cover"
              />
              <div className="absolute bottom-4 sm:bottom-6 left-4 sm:left-6 bg-black/80 backdrop-blur-sm rounded-lg p-3 sm:p-4">
                <p className="text-yellow-400 font-semibold text-sm sm:text-base">Fundadores Cashflow VIP</p>
                <p className="text-white text-xs sm:text-sm">Expertos en crédito</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
